import PlaceThumbnail from './../place-thumbnail';
import PlaceDetail from './../place-detail';
import PlanDirections from './../plan-directions';
import ItemExtras from './item-extras';

var GroupItem = React.createClass({

  render: function(){
    var item = this.props.item;
    
    return (
      <div className={ "item-container " + (item.itemClass || "") }>
        <div className={ "plan-item block bg-primary clearfix" + (item.place_id === 0 ? ' no-thumb' : '') }>
          <PlaceThumbnail item={item} weekday={this.props.weekday} isSmallScreen={this.props.isSmallScreen} groupIndex={this.props.groupIndex + 1} itemIndex={ this.props.itemIndex + 1} autoImageUrls={ this.props.autoImageUrls } />
          <PlaceDetail item={item} weekday={this.props.weekday} groupIndex={this.props.groupIndex + 1} itemIndex={ this.props.itemIndex + 1} isSmallScreen={this.props.isSmallScreen} autoImageUrls={ this.props.autoImageUrls } />
          <ItemExtras item={item} />
        </div>
        
        <PlanDirections directions={item.next} lunchbreakNext={item.lunchbreak_next} isSmallScreen={this.props.isSmallScreen}/>
      </div>
    );
  }
});

module.exports = GroupItem


// WEBPACK FOOTER //
// ./components/guide-components/group-item.js